import * as React from 'react';

import { Typography, Button, Alert, VStack } from '@vivaahealth/design-system';
import { useTranslation } from 'react-i18next';

import * as api from '../../../api';

import { format } from '../../../utils/location';

interface Props {
  originalAddress: api.Places.PlaceDetails;
  suggestedAddress: api.Places.PlaceDetails;
  onAddressSelected?: (address: api.Places.PlaceDetails) => void;
}

export const AddressPicker: React.FC<Props> = ({
  originalAddress,
  suggestedAddress,
  onAddressSelected,
}) => {
  const { t } = useTranslation('addressInput');
  return (
    <VStack gap={32}>
      <Alert variant="warning">{t('mismatch')}</Alert>
      <VStack gap={16}>
        <VStack gap={8}>
          <Typography variant="title-large" bold>
            {t('suggestedAddressLabel')}
          </Typography>
          <Typography variant="paragraph-large">
            {format(suggestedAddress)}
          </Typography>
        </VStack>
        <Button fullWidth onClick={() => onAddressSelected?.(suggestedAddress)}>
          {t('pickSuggestedAddressCTA')}
        </Button>
      </VStack>
      <VStack gap={16}>
        <VStack gap={8}>
          <Typography variant="title-large" bold>
            {t('enteredAddressLabel')}
          </Typography>
          <Typography variant="paragraph-large">
            {format(originalAddress)}
          </Typography>
        </VStack>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => onAddressSelected?.(originalAddress)}
        >
          {t('pickEnteredAddressCTA')}
        </Button>
      </VStack>
    </VStack>
  );
};
